<div class="container">
  <h2>Recursos Pendentes</h2>
  
  <div *ngIf="loading" class="loading">Carregando...</div>
  
  <div *ngIf="!loading && recursos.length === 0" class="no-data">
    Nenhum recurso pendente encontrado.
  </div>
  
  <table *ngIf="!loading && recursos.length > 0" class="appeals-table">
    <thead>
      <tr>
        <th>Protocolo</th>
        <th>Concurso</th>
        <th>Nome</th>
        <th>Tipo</th>
        <th>Data</th>
        <th>Ações</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let recurso of recursos">
        <td>{{ recurso.protocolo }}</td>
        <td>{{ recurso.tituloConcurso }}</td>
        <td>{{ recurso.nomeSocial || recurso.nome }}</td>
        <td>{{ recurso.tipoRecurso }}</td>
        <td>{{ recurso.data | date: 'dd/MM/yyyy HH:mm' }}</td>
        <td>
          <button (click)="visualizarNotas(recurso.id)" class="btn-visualizar">
            Analisar
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
